import React from 'react';
import CreateCampaignBreadcrumbItem from 'components/Campaigns/CreateEdit/BreadcrumbItem';
import './styles.scss';

interface Props {
  currentStep?: number;
}

const CreateCampaignBreadcrumb: React.FC<Props> = ({ currentStep = 1 }) => {
  return (
    <div className="create-campaign-breadcrumb">
      <CreateCampaignBreadcrumbItem
        done={currentStep > 1}
        label="Stores"
        selected={currentStep === 1}
        step={1}
      />
      <div className="separator" />
      <CreateCampaignBreadcrumbItem
        done={currentStep > 2}
        label="Items"
        selected={currentStep === 2}
        step={2}
      />
      <div className="separator" />
      <CreateCampaignBreadcrumbItem
        label="Campaign Details"
        selected={currentStep === 3}
        step={3}
      />
    </div>
  );
};

export default CreateCampaignBreadcrumb;
